import { createFileRoute } from '@tanstack/react-router';
import { zodSearchValidator } from '@tanstack/router-zod-adapter';

import { vesselsSearchSchema } from '../../types/vesselsSearchSchema';
import { VesselOverviewPage } from '../vessel/VesselOverview/VesselOverviewPage';

export const Route = createFileRoute('/_app/vessels')({
    component: VesselOverviewPage,
    validateSearch: zodSearchValidator(vesselsSearchSchema),
});
